import NewAnalysisFileBuilder from './container';

export default (new NewAnalysisFileBuilder()).build();
